import { Button, DatePicker, Input, Select, Table } from 'antd'
import { Option } from 'antd/es/mentions'
import React, { useState, useEffect } from 'react'
// import "../../MainCSS.css";
import 'aos/dist/aos.css'
import axios from 'axios'
import { toast } from 'react-toastify'
import { CreateStockIdData, GetPendingOrderData, GetPendingStockIdData, GetPressOutputData, GetPressOutputRackData, GetStockData, GetStockIdData, SavePressOutputData } from '../../AllAPI/ProductionAPI/ProductionApi'
import { GetPendingOrderList } from '../../AllAPI/ProductionOrderAPI/ProductionOrderApi'
import dayjs from 'dayjs'
import { GetAlloyMaster } from '../../AllAPI/MasterAPI/GeneralMasterApi'
import { TemperMasterGet } from '../../AllAPI/MasterAPI/ProductionMasterApi'
import { DieNameMasterGet } from '../../AllAPI/MasterAPI/DiesMasterApi'
const PressOutput = () => {

  const storedHeaders = JSON.parse(sessionStorage.getItem('authHeaders')) || {}
  // const storedUserData = sessionStorage.getItem('userData') || '';

  const commonHeaders = {
    headers: {
      // createdBy: storedUserData || '',
      // updatedBy: storedUserData || '',
      createdBy: 1,
      updatedBy: 2,
      userIp: storedHeaders.userIp || '',
      userLat: storedHeaders.userLat || '',
      userLong: storedHeaders.userLong || '',
      deviceSign: storedHeaders.deviceSign || '',
    },
  }

  const commonHeaders1 = {
    headers: {
      createdBy: 1,
      updatedBy: 2,
    },
  }

  const [errors, setErrors] = useState({
    pressNumber: '',
    wtPerPcs: '',
    rackNumber: '',
    allPendingOrderId: '',
    lengthSize: '',
    unit: '',
    dieNumber: '',
    dieSubNumber: '',
    wtRange: '',
    quantity: '',
    dieName: '',
    totalPcs: '',
    outputRemark: '',
  })

  const [allPressOutputData, setAllPressOutputData] = useState([])
  const [allPendingData, setAllPendingData] = useState([])
  const [allStockIdData, setAllStockIdData] = useState([])
  const [allRackNumber, setAllRackNumber] = useState([])
  const [allDieName, setAllDieName] = useState([])
  const [allAlloy, setAllAlloy] = useState([])
  const [allTemper, setAllTemper] = useState([])
  const [allPendingOrderId, setAllPendingOrderId] = useState([])
  const [allPendingStockId, setAllPendingStockId] = useState([])

  const [wtPerPcs, setWtPerPcs] = useState('')
  const [rackNumber, setRackNumber] = useState('')
  const [pendingOrderId, setPendingOrderId] = useState('')
  const [stockId, setStockId] = useState('')
  const [lengthSize, setLengthSize] = useState('')
  const [unit, setUnit] = useState('')
  const [dieNumber, setDieNumber] = useState('')
  const [dieSubNumber, setDieSubNumber] = useState('')
  const [wtRange, setWtRange] = useState('')
  const [quantity, setQuantity] = useState('')
  const [dieName, setDieName] = useState(1)
  const [alloyName, setAlloyName] = useState(1)
  const [temperName, setTemperName] = useState(1)
  const [totalPcs, setTotalPcs] = useState('')
  const [outputRemark, setOutputRemark] = useState('')

   const [stockIdAuto, setStockIdAuto] = useState('')
   const [stockEntryDate, setStockEntryDate] = useState(dayjs())

    const [showPendingOrderForm, setShowPendingOrderForm] = useState(false);
    const [showCreateNewStockForm, setShowCreateNewStockForm] = useState(false);
    const [showTable, setShowTable] = useState(true)

    const handleShowPendingOrderForm = () => {
      setShowTable(false)
      setShowPendingOrderForm(true)
    }
    const handleShowCreateNewStockForm = () => {
      fetchStockId()
      setShowTable(false)
      setShowCreateNewStockForm(true)
    }

  // Fetch Press Output Names
  let isPressOutputFetched = false
  useEffect(() => {
    if (isPressOutputFetched) return
    fetchPressOutputData()
    fetchRackNumber()
    fetchDieName()
    fetchAlloy()
    fetchTemper()
    fetchPendingOrderId()
    fetchPendingStockId()
    isPressOutputFetched = true
  }, [])

    useEffect(() => {
      setFilteredData1(allPendingData); // update table when data changes
    }, [allPendingData]);

    useEffect(() => {
      const wt = parseFloat(wtPerPcs);
      const pcs = parseFloat(totalPcs);
      const len = parseFloat(lengthSize);

      if (!isNaN(wt) && !isNaN(pcs) && !isNaN(len) && pcs > 0 && len > 0 && unit) {
        let wtRangeResult = 0;
        let quantityResult = 0;

        if (unit === '1') { // FT
          wtRangeResult = (wt / pcs * 12) / len;
          quantityResult = wt * (len / 12) * pcs;
        } else if (unit === '2') { // MM
          wtRangeResult = (wt / pcs * 3660) / len;
          quantityResult = wt * (len / 3660) * pcs;
        } else if (unit === '3') { // INCH
          wtRangeResult = (wt / pcs * 144) / len;
          quantityResult = wt * (len / 144) * pcs;
        }

        setWtRange(wtRangeResult.toFixed(2));
        setQuantity(quantityResult.toFixed(2));
      } else {
        setWtRange('');
        setQuantity('');
      }
    }, [wtPerPcs, totalPcs, lengthSize, unit]);

//=============================================

    const fetchStockId = async () => { 
     try {
       const response = await axios.get(
         `${GetStockIdData}`,
         commonHeaders1,
       )
       if (response.data !== null) {
         setStockIdAuto(response.data);
       }
     } catch (error) {
       if (!isError) {
         console.error('Error fetching stock ID:', error);
         toast.error('Failed to fetch stock ID data')
         isError = true
       }
     }
   }


   //======Outside Table===============

   const [pageSize, setPageSize] = useState(10)
   const [filteredData, setFilteredData] = useState([])
   const [currentPage, setCurrentPage] = useState(1)
   const [totalEntries, setTotalEntries] = useState(0)
 
   const handleSearch = (value) => {
     const filtered = allPressOutputData.filter((item) =>
       Object.values(item).some((val) =>
         val.toString().toLowerCase().includes(value.toLowerCase()),
       ),
     )
     setFilteredData(filtered)
     setTotalEntries(filtered.length) // Update total entries count after filtering
     setCurrentPage(1)
   }
 
   const handlePageSizeChange = (value) => {
     setPageSize(value)
   }
 
   const fetchPressOutputData = async () => { 
     try {
       const response = await axios.get(
         `${GetPressOutputData}`,
         commonHeaders1,
       )
       if (response.data !== null) {
          setAllPressOutputData(response.data)
          setFilteredData(response.data);
          setTotalEntries(response.data.length);
       }
     } catch (error) {
       if (!isError) {
         console.error('Error fetching Press Output Data:', error)
         toast.error('Failed to fetch Press Output Data data')
         isError = true
       }
     }
   }
 

  const columns = [
  {
    title: 'Sr.No.',
    dataIndex: 'srNo',
    key: 'index',
    render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: 'Id',
    dataIndex: 'pendingOrderId',
    key: 'pendingOrderId',
    sorter: (a, b) => {
      const aVal = !a.stockId ? a.pendingOrderId : a.stockId;
      const bVal = !b.stockId ? b.pendingOrderId : b.stockId;
      return String(aVal ?? '').localeCompare(String(bVal ?? ''));
    },
    render: (text, record) => {
      const { stockId, pendingOrderId } = record;
      let displayValue = null;
      if (!stockId) displayValue = pendingOrderId;
      else if (!pendingOrderId) displayValue = stockId;
      else displayValue = pendingOrderId;
      return <div style={{ textAlign: 'right' }}>{displayValue}</div>;
    },
  },
  {
    title: 'Item Name',
    dataIndex: 'dieName',
    key: 'dieName',
    sorter: (a, b) => String(a.dieName ?? '').localeCompare(String(b.dieName ?? '')),
  },
  {
    title: 'Wt',
    dataIndex: 'wtPerPcs',
    key: 'wtPerPcs',
    sorter: (a, b) => (a.wtPerPcs || 0) - (b.wtPerPcs || 0),
    render: (text) => <div style={{ textAlign: 'right' }}>{text}</div>,
  },
  {
    title: 'Length',
    dataIndex: 'length',
    key: 'length',
    sorter: (a, b) => (a.length || 0) - (b.length || 0),
    render: (text, record) => {
      let unitLabel = '';
      if (record.unit === 1) unitLabel = '(FT)';
      else if (record.unit === 2) unitLabel = '(MM)';
      else if (record.unit === 3) unitLabel = '(Inch)';
      return `${record.length} ${unitLabel}`;
    },
  },
  {
    title: 'Pcs',
    dataIndex: 'totalPcs',
    key: 'totalPcs',
    sorter: (a, b) => (a.totalPcs || 0) - (b.totalPcs || 0),
    render: (text) => <div style={{ textAlign: 'right' }}>{text}</div>,
  },
  {
    title: 'Qty',
    dataIndex: 'qty',
    key: 'qty',
    sorter: (a, b) => (a.qty || 0) - (b.qty || 0),
    render: (text) => <div style={{ textAlign: 'right' }}>{text}</div>,
  },
  {
    title: 'Party Name',
    dataIndex: 'customerName',
    key: 'customerName',
    sorter: (a, b) => String(a.customerName ?? '').localeCompare(String(b.customerName ?? '')),
  },
  {
    title: 'Alloy',
    dataIndex: 'alloyName',
    key: 'alloyName',
      render: (text) => text ? text : 'NA',
    sorter: (a, b) => String(a.alloyName ?? '').localeCompare(String(b.alloyName ?? '')),
  },
  {
    title: 'Temper',
    dataIndex: 'temperName',
    key: 'temperName',
      render: (text) => text ? text : 'NA',
    sorter: (a, b) => String(a.temperName ?? '').localeCompare(String(b.temperName ?? '')),
  },
]
 
   const components = {
     header: {
       cell: ({ children, ...restProps }) => (
         <th
           {...restProps}
           style={{
             backgroundColor: '#023e7d',
             color: '#fff',
             padding: '10px',
             fontSize: '15px',
             borderRadius: '0px',
           }}
         >
           {children}
         </th>
       ),
     },
     body: {
       row: ({ children, ...restProps }) => (
         <tr
           {...restProps}
           style={{
             backgroundColor: '#f0f7fd',
           }}
         >
           {children}
         </tr>
       ),
       cell: ({ children, ...restProps }) => (
         <td
           {...restProps}
           style={{
             padding: '8px',
             fontSize:'15px'
           }}
         >
           {children}
         </td>
       ),
     },
   }

  //======Pending Order Table===============

  const [pageSize1, setPageSize1] = useState(10)
  const [filteredData1, setFilteredData1] = useState([])
  const [currentPage1, setCurrentPage1] = useState(1)
  const [totalEntries1, setTotalEntries1] = useState(0)

  const handleSearch1 = (value) => {
    const filtered = allPendingData.filter((item) =>
      Object.values(item).some((val) =>
        val.toString().toLowerCase().includes(value.toLowerCase()),
      ),
    )
    setFilteredData1(filtered)
    setTotalEntries1(filtered.length) // Update total entries count after filtering
    setCurrentPage1(1)
  }

  const handlePageSizeChange1 = (value) => {
    setPageSize1(value)
  }

  let isError = false

  const fetchPendingData = async (pendingOrderId) => {
    try {
      const response = await axios.get(
        `${GetPendingOrderData}?id=${pendingOrderId}`,
        commonHeaders1,
      )
      if (response.data !== null) {
        setAllPendingData(response.data)
        setDieName(response.data[0].dieName)
        setUnit(response.data[0].unit ? String(response.data[0].unit) : null);
      }
    } catch (error) {
      if (!isError) {
        console.error('Error fetching Pending Data:', error)
        toast.error('Failed to fetch Pending Data data')
        isError = true // Set the flag to prevent double toast
      }
    }
  }


  const columns1 = [
  {
    title: 'Sr.No.',
    dataIndex: '',
    key: 'index',
    render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: 'Pending Order Id',
    dataIndex: 'pendingOrder',
    key: 'pendingOrder',
    sorter: (a, b) => String(a.pendingOrder ?? '').localeCompare(String(b.pendingOrder ?? '')),
  },
  {
    title: 'Item Name',
    dataIndex: 'dieName',
    key: 'dieName',
    sorter: (a, b) => String(a.dieName ?? '').localeCompare(String(b.dieName ?? '')),
  },
  {
    title: 'Wt',
    dataIndex: 'weight',
    key: 'weight',
    sorter: (a, b) => (a.weight ?? 0) - (b.weight ?? 0),
  },
  {
    title: 'Length',
    dataIndex: 'length',
    key: 'length',
    sorter: (a, b) => (a.length ?? 0) - (b.length ?? 0),
    render: (text, record) => {
      let unitLabel = '';
      if (record.unit === 1) unitLabel = '(FT)';
      else if (record.unit === 2) unitLabel = '(MM)';
      else if (record.unit === 3) unitLabel = '(Inch)';
      return `${record.length} ${unitLabel}`;
    },
  },
  {
    title: 'Pcs',
    dataIndex: 'pendingOrderPcs',
    key: 'pendingOrderPcs',
    sorter: (a, b) => (a.pendingOrderPcs ?? 0) - (b.pendingOrderPcs ?? 0),
  },
  {
    title: 'Qty',
    dataIndex: 'pendingOrderQty',
    key: 'pendingOrderQty',
    sorter: (a, b) => (a.pendingOrderQty ?? 0) - (b.pendingOrderQty ?? 0),
  },
  {
    title: 'Party Name',
    dataIndex: 'customerName',
    key: 'customerName',
    sorter: (a, b) => String(a.customerName ?? '').localeCompare(String(b.customerName ?? '')),
  },
  {
    title: 'Alloy',
    dataIndex: 'alloyName',
    key: 'alloyName',
      render: (text) => text ? text : 'NA',
    sorter: (a, b) => String(a.alloyName ?? '').localeCompare(String(b.alloyName ?? '')),
  },
  {
    title: 'Temper',
    dataIndex: 'temperName',
    key: 'temperName',
      render: (text) => text ? text : 'NA',
    sorter: (a, b) => String(a.temperName ?? '').localeCompare(String(b.temperName ?? '')),
  },
];


  const components1 = {
    header: {
      cell: ({ children, ...restProps }) => (
        <th
          {...restProps}
          style={{
            backgroundColor: '#023e7d',
            color: '#fff',
            padding: '10px',
            fontSize: '15px',
            borderRadius: '0px',
          }}
        >
          {children}
        </th>
      ),
    },
    body: {
      row: ({ children, ...restProps }) => (
        <tr
          {...restProps}
          style={{
            backgroundColor: '#f0f7fd',
          }}
        >
          {children}
        </tr>
      ),
      cell: ({ children, ...restProps }) => (
        <td
          {...restProps}
          style={{
            padding: '8px',
            fontSize:'15px'
          }}
        >
          {children}
        </td>
      ),
    },
  }
//==============================================


  const fetchRackNumber = async () => {
    try {
      const response = await axios.get(GetPressOutputRackData, commonHeaders1)
      if (response.data !== null) {
        setAllRackNumber(response.data)
      }
    } catch (error) {
      if (!isError) {
        console.error('Error fetching Rack Number:', error)
        toast.error('Failed to fetch Rack Number data')
        isError = true // Set the flag to prevent double toast
      }
    }
  }

    const fetchDieName = async () => {
    try {
      const response = await axios.get(DieNameMasterGet, commonHeaders1)
      if (response.data !== null) {
        setAllDieName(response.data)
      }
    } catch (error) {
      if (!isError) {
        console.error('Error fetching Die Name:', error)
        toast.error('Failed to fetch Die Name data')
        isError = true // Set the flag to prevent double toast
      }
    }
  }

    const fetchAlloy = async () => {
    try {
      const response = await axios.get(GetAlloyMaster, commonHeaders1)
      if (response.data !== null) {
        setAllAlloy(response.data)
      }
    } catch (error) {
      if (!isError) {
        console.error('Error fetching Alloy:', error)
        toast.error('Failed to fetch Alloy data')
        isError = true // Set the flag to prevent double toast
      }
    }
  }

    const fetchTemper = async () => {
    try {
      const response = await axios.get(TemperMasterGet, commonHeaders1)
      if (response.data !== null) {
        setAllTemper(response.data)
      }
    } catch (error) {
      if (!isError) {
        console.error('Error fetching Temper:', error)
        toast.error('Failed to fetch Temper data')
        isError = true // Set the flag to prevent double toast
      }
    }
  }

  const fetchPendingOrderId = async () => {
    try {
      const response = await axios.get(GetPendingOrderList, commonHeaders1)
      if (response.data !== null) {
        setAllPendingOrderId(response.data)
      }
    } catch (error) {
      if (!isError) {
        console.error('Error fetching Pending Order Id:', error)
        toast.error('Failed to fetch Pending Order Id data')
        isError = true // Set the flag to prevent double toast
      }
    }
  }
  const fetchPendingStockId = async () => {
    try {
      const response = await axios.get(GetPendingStockIdData, commonHeaders1)
      if (response.data !== null) {
        setAllPendingStockId(response.data)
      }
    } catch (error) {
      if (!isError) {
        console.error('Error fetching Pending Order Id:', error)
        toast.error('Failed to fetch Pending Order Id data')
        isError = true // Set the flag to prevent double toast
      }
    }
  }

  //============================================
  const handlePressOutputAllCancel = () => {
    setAllPendingData([])
    setPendingOrderId("")
    handlePressOutputCancel();
    setShowPendingOrderForm(false)
    setShowTable(true)
  }
  const handlePressOutputCancel = () => {
      setWtPerPcs('')
      setRackNumber('')
      setLengthSize('')
      setUnit('')
      setDieNumber('')
      setDieSubNumber('')
      setWtRange('')
      setQuantity('')
      setDieName(1)
      setAlloyName(1)
      setTemperName(1)
      setTotalPcs('')
      setOutputRemark('')
      setErrors('')
  }
  const handlePressOutputSubmit = async () => {

    let isValid = true;
    const errorObj = {};  

    if (!dieSubNumber) {
      isValid = false;
      errorObj.dieSubNumber = "Die Sub Number is required *";
    }
    if (!pendingOrderId) {
      isValid = false;
      errorObj.pendingOrderId = "Pending Order Id is required *";
    }
    if (!dieNumber) {
      isValid = false;
      errorObj.dieNumber = "Die Number is required *";
    }
    if (!dieName) {
      isValid = false;
      errorObj.dieName = "Die Name is required *";
    }
    if (!wtPerPcs) {
      isValid = false;
      errorObj.wtPerPcs = "Wt Per Pcs is required *";
    }
    if (!lengthSize) {
      isValid = false;
      errorObj.lengthSize = "Length is required *";
    }
    if (!totalPcs) {
      isValid = false;
      errorObj.totalPcs = "Total Pcs is required *";
    }
    if (!rackNumber) {
      isValid = false;
      errorObj.rackNumber = "Rack Number is required *";
    }
    if (!unit) {
      isValid = false;
      errorObj.unit = "Unit is required *";
    }
    if (!outputRemark) {
      isValid = false;
      errorObj.outputRemark = "Output Remark is required *";
    }

    setErrors(errorObj); // Set error messages
    
        if (!isValid) return;

    const saveData ={
      pendingOrderId:parseFloat(pendingOrderId),
      wtPerPcs:parseFloat(wtPerPcs),
      totalPcs:parseFloat(totalPcs),
      dieNumber:parseFloat(dieNumber),
      dieSubNumber:parseFloat(dieSubNumber),
      length:parseFloat(lengthSize),
      rackNumberId:parseFloat(rackNumber),
      unit:parseFloat(unit),
      dieName:dieName,
      remark:outputRemark,
      qty:parseFloat(quantity),
      wtRange:parseFloat(wtRange),
    }

    
            try {
              const response = await axios.post(SavePressOutputData, saveData,commonHeaders);
    
              if (response.data === "CREATED") {
                toast.success("Press Output Submitted successfully!");
                handlePressOutputCancel();
                fetchPendingData(pendingOrderId);
                fetchPressOutputData();
              }
              else if (response.data === "ALREADYEXISTED") {
                toast.warn("Order Details already exist!");
              }
            } catch (error) {
              console.error("Error during API call:", error);
              toast.error("Error occurred while submitting this data");
            }

  }

   const handleNewStockAllCancel = () => {
    setAllStockIdData([])
    setStockId("")
    handleNewStockCancel();
    setShowCreateNewStockForm(false)
    setShowTable(true)
  }
  const handleNewStockCancel = () => {
      fetchPressOutputData()
      setStockId('')
      setWtPerPcs('')
      setRackNumber('')
      setLengthSize('')
      setUnit('')
      setDieNumber('')
      setDieSubNumber('')
      setWtRange('')
      setQuantity('')
      setDieName(1)
      setAlloyName(1)
      setTemperName(1)
      setTotalPcs('')
      setOutputRemark('')
      setErrors('')
      setShowTable(true)
      setShowPendingOrderForm(false)
      setShowCreateNewStockForm(false)

  }

  const handleNewStockEntrySubmit = async () => {

    let isValid = true;
    const errorObj = {};  

    if (!dieSubNumber) {
      isValid = false;
      errorObj.dieSubNumber = "Die Sub Number is required *";
    }
    if (!stockId) {
      isValid = false;
      errorObj.stockId = "Pending Order Id is required *";
    }
    if (!dieNumber) {
      isValid = false;
      errorObj.dieNumber = "Die Number is required *";
    }
    if (!dieName) {
      isValid = false;
      errorObj.dieName = "Die Name is required *";
    }
     if (!alloyName) {
      isValid = false;
      errorObj.alloyName = "Alloy Name is required *";
    }
     if (!temperName) {
      isValid = false;
      errorObj.temperName = "Temper Name is required *";
    }
    if (!wtPerPcs) {
      isValid = false;
      errorObj.wtPerPcs = "Wt Per Pcs is required *";
    }
    if (!lengthSize) {
      isValid = false;
      errorObj.lengthSize = "Length is required *";
    }
    if (!totalPcs) {
      isValid = false;
      errorObj.totalPcs = "Total Pcs is required *";
    }
    if (!rackNumber) {
      isValid = false;
      errorObj.rackNumber = "Rack Number is required *";
    }
    if (!unit) {
      isValid = false;
      errorObj.unit = "Unit is required *";
    }
    if (!outputRemark) {
      isValid = false;
      errorObj.outputRemark = "Output Remark is required *";
    }

    setErrors(errorObj); // Set error messages
    
        if (!isValid) return;

    const saveData ={
      stockId:parseFloat(stockId),
      wtPerPcs:parseFloat(wtPerPcs),
      totalPcs:parseFloat(totalPcs),
      dieNumber:parseFloat(dieNumber),
      dieSubNumber:parseFloat(dieSubNumber),
      length:parseFloat(lengthSize),
      rackNumberId:parseFloat(rackNumber),
      unit:parseFloat(unit),
      dieNameId:parseFloat(dieName),
      alloyId:parseFloat(alloyName),
      temperId:parseFloat(temperName),
      remark:outputRemark,
      qty:parseFloat(quantity),
      wtRange:parseFloat(wtRange),
    }

    
            try {
              const response = await axios.post(SavePressOutputData, saveData,commonHeaders);
    
              if (response.data === "CREATED") {
                toast.success("New Stock Submitted successfully!");
                handleNewStockCancel();
              }
              else if (response.data === "NOTFOUND") {
                toast.warn("DATA NOTFOUND!");
              }
            } catch (error) {
              console.error("Error during API call:", error);
              toast.error("Error occurred while submitting this data");
            }

  }
  const handleStockIdCreate = async () => { 

    let isValid = true;
    const errorObj = {};  

    if (!stockIdAuto) {
      isValid = false;
      errorObj.stockIdAuto = "Stock Id is required *";
    }
    if (!stockEntryDate) {
      isValid = false;
      errorObj.stockEntryDate = "Stock Entry Date is required *";
    }

    setErrors(errorObj); // Set error messages
    
        if (!isValid) return;

         const formattedDate = stockEntryDate? dayjs(stockEntryDate).format('DD/MM/YYYY'): '';

          const saveData ={
            stockId:stockIdAuto,
            stockEntryDate:formattedDate,
          }
    
            try {
              const response = await axios.post(CreateStockIdData, saveData,commonHeaders);
    
              if (response.data === "CREATED") {
                toast.success("New Stock Id Created successfully!");
                fetchPendingStockId();
              }
              else if (response.data === "ALREADYEXISTED") {
                toast.warn("New Stock Id already exist!");
              }
            } catch (error) {
              console.error("Error during API call:", error);
              toast.error("Error occurred while submitting this data");
            }

  }

  //===========================================
  const unitOptions = [
    { value: '1', label: 'FT' },
    { value: '2', label: 'MM' },
    { value: '3', label: 'INCH' },
  ]

  const dateFormatList = ['DD/MM/YYYY', 'DD/MM/YY', 'DD-MM-YYYY', 'DD-MM-YY']
  //====================================================

  return (
    <div className="px-md-5 py-md-3">

        <div  className="row mt-3 p-md-3 pt-2 pb-5 mb-5 rounded" style={{backgroundColor:"#e0efff"}}>

           {/*================ Outside Table (first)=========================*/}
            <div className="col-12">
              {showTable && (
                      <div className="px-lg-5 py-1" >
                          <div className="row mt-3 p-3 py-1  rounded" style={{backgroundColor:"#e0efff"}}>
                            <div className="col-12 text-start">
                            </div>
                              <div
                                className="col-12 py-3 shadow border rounded"
                                style={{  backgroundColor: "white" }}
                              >
        
                              <div className="row ps-2 m-0 mb-2">
                                <div className="col-12 col-md-3">
                                  <Button
                                    onClick={handleShowPendingOrderForm}
                                    style={{ backgroundColor: '#f8bf28' }}
                                  >
                                    Add Pending Order +
                                  </Button>
                                </div>
                                <div className="col-12 col-md-3">
                                  <Button
                                    onClick={handleShowCreateNewStockForm}
                                    style={{ backgroundColor: '#f8bf28' }}
                                  >
                                    Create New Stock +
                                  </Button>
                                </div>
                                <div className="col-12 col-md-6"></div>
                              </div>
        
                                <div
                                  className="col-12 px-lg-5"
                                  style={{ display: "flex", justifyContent: "space-between" }}
                                >
                                  <div>
                                    <span style={{ fontSize: "14px" }}>Show entries &nbsp;</span>
                                    <Select
                                      defaultValue={pageSize}
                                      onChange={handlePageSizeChange}
                                      style={{ width: 120, textAlign: "center" }}
                                    >
                                      <Option value={10}>10</Option>
                                      <Option value={20}>20</Option>
                                      <Option value={30}>30</Option>
                                    </Select>
                                  </div>
        
                                  <div className="pt-4 pt-lg-0">
                                    <Input.Search
                                      placeholder="Search"
                                      onChange={(e) => handleSearch(e.target.value)}
                                      style={{ width: 200, marginBottom: 16 }}
                                    />
                                  </div>
                                </div>
        
                                <div style={{ backgroundColor: "white" }}>
                                  <Table
                                    bordered
                                    style={{ padding: "0px 20px", overflowX: "auto" }}
                                    columns={columns}
                                    dataSource={filteredData}
                                    pagination={{
                                      pageSize: pageSize,
                                      total: totalEntries,
                                      showTotal: (total, range) =>
                                        `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                                      current: currentPage,
                                      onChange: (page) => setCurrentPage(page),
                                    }}
                                    showSorterTooltip={false}
                                    rowKey={(record) => record.id}
                                    components={components}
                                  />
                                </div>
                                
                              </div>
                          </div>
                      </div>
                )}
            </div>

            {showPendingOrderForm && (
                <div className="col-12">
                    <div className="row  mb-3" >
                    <div   className="col-12 py-1 shadow border rounded"
                            style={{ backgroundColor: "white", }}
                          >
                      <div className="col-12 px-lg-5"
                        style={{ display: 'flex', justifyContent: 'space-between' }}
                      >
                        <div>
                          <span style={{ fontSize: '14px' }}>Show entries &nbsp;</span>
                          <Select
                            defaultValue={pageSize1}
                            onChange={handlePageSizeChange1}
                            style={{ width: 120, textAlign: 'center' }}
                          >
                            <Option value={10}>10</Option>
                            <Option value={20}>20</Option>
                            <Option value={30}>30</Option>
                          </Select>
                        </div>

                        <div className="pt-lg-0">
                          <Input.Search
                            placeholder="Search"
                            onChange={(e) => handleSearch1(e.target.value)}
                            style={{ width: 200, marginBottom: 5 }}
                          />
                        </div>
                      </div>

                      <div style={{backgroundColor: "white",}}>
                        <Table
                          bordered
                          style={{ padding: "0px 20px",overflowX: 'auto',}}
                          columns={columns1}
                          dataSource={filteredData1}
                          pagination={{
                            pageSize: pageSize1,
                            total: totalEntries1,
                            showTotal: (total, range) =>
                              `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                            current: currentPage1,
                            onChange: (page) => setCurrentPage1(page),
                          }}
                          showSorterTooltip={false}
                          rowKey={(record) => record.id}
                          components={components1}
                        />
                      </div>

                    </div>
                    </div>

                    <div className="row  mt-3">
                      <div className="col-md-6 col-lg-4 py-1">
                        <label className="labels">PendingOrder ID</label>
                        <Select
                          value={pendingOrderId || undefined}
                          onChange={(value) => {
                            setPendingOrderId(value)
                            fetchPendingData(value) // pass selected ID
                          }}
                          showSearch
                          className="w-100"
                          placeholder="Select Id"
                          optionFilterProp="children"
                        >
                          {allPendingOrderId.map((pendingOrder) => (
                            <Option key={pendingOrder.id} value={pendingOrder.id}>
                              {pendingOrder.pendingOrder}
                            </Option>
                          ))}
                        </Select>
                        {errors.pendingOrderId && (
                          <div className="errorField">{errors.pendingOrderId}</div>
                        )}
                      </div>
                      <div className="col-md-6 col-lg-4 py-1">
                        <label className="labels">Wt Per Pcs</label>
                        <Input
                          value={wtPerPcs}
                          onChange={(e) => setWtPerPcs(e.target.value)}
                          placeholder="Enter Pcs"
                          maxLength={250}
                        />
                        {errors.wtPerPcs && (
                          <div className="errorField">{errors.wtPerPcs}</div>
                        )}
                      </div>
                      <div className="col-md-6 col-lg-4 py-1">
                        <label className="labels">Total Pcs</label>
                        <Input
                          value={totalPcs}
                          onChange={(e) => setTotalPcs(e.target.value)}
                          placeholder="Enter Pcs"
                          maxLength={250}
                        />
                        {errors.totalPcs && (
                          <div className="errorField">{errors.totalPcs}</div>
                        )}
                      </div>
                      <div className="col-md-6 col-lg-4 py-1">
                        <label className="labels">Rack Number</label>
                        <Select
                          value={rackNumber || undefined}
                          onChange={setRackNumber}
                          showSearch
                          className="w-100"
                          placeholder="Select Number"
                          optionFilterProp="children"
                        >
                          {allRackNumber.map((rack) => (
                            <Option key={rack.rackNumberId} value={rack.rackNumberId}>
                              {rack.racknumber}
                            </Option>
                          ))}
                        </Select>
                        {errors.rackNumber && (
                          <div className="errorField">{errors.rackNumber}</div>
                        )}
                      </div>
                      <div className="col-md-6 col-lg-4 py-1">
                        <label className="labels">Length</label>
                        <Input
                          value={lengthSize}
                          onChange={(e) => setLengthSize(e.target.value)}
                          placeholder="Enter Length"
                          maxLength={250}
                        />
                        {errors.lengthSize && <div className="errorField">{errors.lengthSize}</div>}
                      </div>
                      <div className="col-md-6 col-lg-4 py-1">
                        <label className="labels">Unit</label>
                        <Select
                          value={unit || undefined}
                          onChange={setUnit}
                          showSearch
                          className="w-100"
                          placeholder="Select Unit"
                          optionFilterProp="children"
                        >
                          {unitOptions.map((opt) => (
                            <Option key={opt.value} value={opt.value}>
                              {opt.label}
                            </Option>
                          ))}
                        </Select>
                        {errors.unit && <div className="errorField">{errors.unit}</div>}
                      </div>
                      <div className="col-md-6 col-lg-4 py-1">
                        <label className="labels">Die Number</label>
                        <Input
                          value={dieNumber}
                          onChange={(e) => setDieNumber(e.target.value)}
                          placeholder="Enter Number"
                          maxLength={250}
                        />
                        {errors.dieNumber && (
                          <div className="errorField">{errors.dieNumber}</div>
                        )}
                      </div>
                      <div className="col-md-6 col-lg-4 py-1">
                        <label className="labels">Die Sub Number</label>
                        <Input
                          value={dieSubNumber}
                          onChange={(e) => setDieSubNumber(e.target.value)}
                          placeholder="Enter Number"
                          maxLength={250}
                        />
                        {errors.dieSubNumber && (
                          <div className="errorField">{errors.dieSubNumber}</div>
                        )}
                      </div>
                      <div className="col-md-6 col-lg-4 py-1">
                        <label className="labels">Die Name</label>
                        <Input
                          value={dieName}
                          onChange={(e) => setDieName(e.target.value)}
                          placeholder="Enter Name"
                          maxLength={250}
                        />
                        {errors.dieName && <div className="errorField">{errors.dieName}</div>}
                      </div>

                      <div className="col-md-6 col-lg-4 py-1">
                        <label className="labels">Wt Range</label>
                        <Input
                          readOnly style={{backgroundColor:"#e6e6e6"}}
                          value={wtRange}
                          onChange={(e) => setWtRange(e.target.value)}
                          placeholder="Enter Range"
                          maxLength={250}
                        />
                        {errors.wtRange && <div className="errorField">{errors.wtRange}</div>}
                      </div>
                      <div className="col-md-6 col-lg-4 py-1">
                        <label className="labels">Quantity</label>
                        <Input
                          readOnly style={{backgroundColor:"#e6e6e6"}}
                          value={quantity}
                          onChange={(e) => setQuantity(e.target.value)}
                          placeholder="Enter Qty"
                          maxLength={250}
                        />
                        {errors.quantity && (
                          <div className="errorField">{errors.quantity}</div>
                        )}
                      </div>

                      <div className="col-md-6 col-lg-4 py-1">
                        <label className="labels">Output Remark</label>
                        <Input
                          value={outputRemark}
                          onChange={(e) => setOutputRemark(e.target.value)}
                          placeholder="Enter Remark"
                          maxLength={250}
                        />
                        {errors.outputRemark && (
                          <div className="errorField">{errors.outputRemark}</div>
                        )}
                      </div>

                      <div className="col-12 text-center pt-3">
                        <Button
                          type="submit"
                          className="CancelBtn mx-1"
                          onClick={handlePressOutputAllCancel}
                        >
                          Cancel
                        </Button>
                        <Button
                          type="submit"
                          className="SubmitBtn mx-1"
                          onClick={handlePressOutputSubmit}
                        >
                          Submit
                        </Button>
                      </div>
                    </div>
                </div>
            )}

            {showCreateNewStockForm && (
                <div className="col-12">
                
                    <div className="row">
                      <div className="col-md-6 col-lg-4 py-1">
                        <label className="labels">Stock Id</label>
                        <Input readOnly
                          value={stockIdAuto}
                          onChange={(e) => setStockIdAuto(e.target.value)}
                          placeholder="Enter Stock Id"
                          style={{backgroundColor:"#e9e9e9e9"}}
                          maxLength={250}
                        />
                      </div>
                      <div className="col-md-6 col-lg-4 py-1">
                        <label className="labels">Stock Entry Date</label>
                       <DatePicker
                          className="w-100"
                          format={dateFormatList}
                          value={stockEntryDate}
                          onChange={(value) => setStockEntryDate(value)}
                        />
                      </div>
                      <div className="col-md-6 col-lg-4 py-1">
                       <Button
                          type="submit"
                          className="SubmitBtn mx-1 mt-4"
                          onClick={handleStockIdCreate}
                        >
                          Create StockId
                        </Button>
                      </div>
                    </div>

                    <div className="col-12 my-2" style={{borderBottom:"1px solid grey"}}></div>

                    {/* <div className="row  mb-3" >
                    <div   className="col-12 py-1 shadow border rounded"
                            style={{ backgroundColor: "white", }}
                          >
                      <div className="col-12 px-lg-5"
                        style={{ display: 'flex', justifyContent: 'space-between' }}
                      >
                        <div>
                          <span style={{ fontSize: '14px' }}>Show entries &nbsp;</span>
                          <Select
                            defaultValue={pageSize2}
                            onChange={handlePageSizeChange2}
                            style={{ width: 120, textAlign: 'center' }}
                          >
                            <Option value={10}>10</Option>
                            <Option value={20}>20</Option>
                            <Option value={30}>30</Option>
                          </Select>
                        </div>

                        <div className="pt-lg-0">
                          <Input.Search
                            placeholder="Search"
                            onChange={(e) => handleSearch2(e.target.value)}
                            style={{ width: 200, marginBottom: 5 }}
                          />
                        </div>
                      </div>

                      <div style={{backgroundColor: "white",}}>
                        <Table
                          bordered
                          style={{ padding: "0px 20px",overflowX: 'auto',}}
                          columns={columns2}
                          dataSource={filteredData2}
                          pagination={{
                            pageSize: pageSize2,
                            total: totalEntries2,
                            showTotal: (total, range) =>
                              `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                            current: currentPage2,
                            onChange: (page) => setCurrentPage2(page),
                          }}
                          showSorterTooltip={false}
                          rowKey={(record) => record.id}
                          components={components2}
                        />
                      </div>

                    </div>
                    </div> */}

                    <div className="row  mt-3">
                      <div className="col-md-6 col-lg-4 py-1">
                        <label className="labels">Stock ID</label>
                        <Select
                          value={stockId || undefined}
                          onChange={(value) => {
                            setStockId(value)
                          }}
                          showSearch
                          className="w-100"
                          placeholder="Select Id"
                          optionFilterProp="children"
                        >
                          {allPendingStockId.map((stock) => (
                            <Option key={stock.id} value={stock.id}>
                              {stock.stockId}
                            </Option>
                          ))}
                        </Select>
                        {errors.stockId && (
                          <div className="errorField">{errors.stockId}</div>
                        )}
                      </div>

                      <div className="col-md-6 col-lg-4 py-1">
                        <label className="labels">Wt Per Pcs</label>
                        <Input
                          value={wtPerPcs}
                          onChange={(e) => setWtPerPcs(e.target.value)}
                          placeholder="Enter Pcs"
                          maxLength={250}
                        />
                        {errors.wtPerPcs && (
                          <div className="errorField">{errors.wtPerPcs}</div>
                        )}
                      </div>

                      <div className="col-md-6 col-lg-4 py-1">
                        <label className="labels">Total Pcs</label>
                        <Input
                          value={totalPcs}
                          onChange={(e) => setTotalPcs(e.target.value)}
                          placeholder="Enter Pcs"
                          maxLength={250}
                        />
                        {errors.totalPcs && (
                          <div className="errorField">{errors.totalPcs}</div>
                        )}
                      </div>

                      <div className="col-md-6 col-lg-4 py-1">
                        <label className="labels">Rack Number</label>
                        <Select
                          value={rackNumber || undefined}
                          onChange={setRackNumber}
                          showSearch
                          className="w-100"
                          placeholder="Select Number"
                          optionFilterProp="children"
                        >
                          {allRackNumber.map((rack) => (
                            <Option key={rack.rackNumberId} value={rack.rackNumberId}>
                              {rack.racknumber}
                            </Option>
                          ))}
                        </Select>
                        {errors.rackNumber && (
                          <div className="errorField">{errors.rackNumber}</div>
                        )}
                      </div>

                      <div className="col-md-6 col-lg-4 py-1">
                        <label className="labels">Length</label>
                        <Input
                          value={lengthSize}
                          onChange={(e) => setLengthSize(e.target.value)}
                          placeholder="Enter Length"
                          maxLength={250}
                        />
                        {errors.lengthSize && <div className="errorField">{errors.lengthSize}</div>}
                      </div>

                      <div className="col-md-6 col-lg-4 py-1">
                        <label className="labels">Unit</label>
                        <Select
                          value={unit || undefined}
                          onChange={setUnit}
                          showSearch
                          className="w-100"
                          placeholder="Select Unit"
                          optionFilterProp="children"
                        >
                          {unitOptions.map((opt) => (
                            <Option key={opt.value} value={opt.value}>
                              {opt.label}
                            </Option>
                          ))}
                        </Select>
                        {errors.unit && <div className="errorField">{errors.unit}</div>}
                      </div>

                      <div className="col-md-6 col-lg-4 py-1">
                        <label className="labels">Die Number</label>
                        <Input
                          value={dieNumber}
                          onChange={(e) => setDieNumber(e.target.value)}
                          placeholder="Enter Number"
                          maxLength={250}
                        />
                        {errors.dieNumber && (
                          <div className="errorField">{errors.dieNumber}</div>
                        )}
                      </div>

                      <div className="col-md-6 col-lg-4 py-1">
                        <label className="labels">Die Sub Number</label>
                        <Input
                          value={dieSubNumber}
                          onChange={(e) => setDieSubNumber(e.target.value)}
                          placeholder="Enter Number"
                          maxLength={250}
                        />
                        {errors.dieSubNumber && (
                          <div className="errorField">{errors.dieSubNumber}</div>
                        )}
                      </div>

                      {/* <div className="col-md-6 col-lg-4 py-1">
                        <label className="labels">Die Name</label>
                        <Input
                          value={dieName}
                          onChange={(e) => setDieName(e.target.value)}
                          placeholder="Enter Name"
                          maxLength={250}
                        />
                        {errors.dieName && <div className="errorField">{errors.dieName}</div>}
                      </div> */}

                       <div className="col-md-6 col-lg-4 py-1">
                        <label className="labels">Die Name</label>
                       <Select
                          value={dieName || undefined}
                          onChange={setDieName}
                          showSearch
                          className="w-100"
                          placeholder="Select Name"
                          optionFilterProp="children"
                        >
                          {allDieName.map((diaName) => (
                            <Option key={diaName.id} value={diaName.id}>
                              {diaName.dieName}
                            </Option>
                          ))}
                        </Select>
                        {errors.dieName && (
                          <div className="errorField">{errors.dieName}</div>
                        )}
                      </div>

                         <div className="col-md-6 col-lg-4 py-1">
                        <label className="labels">Alloy Name</label>
                       <Select
                          value={alloyName || undefined}
                          onChange={setAlloyName}
                          showSearch
                          className="w-100"
                          placeholder="Select Name"
                          optionFilterProp="children"
                        >
                          {allAlloy.map((alloyName) => (
                            <Option key={alloyName.id} value={alloyName.id}>
                              {alloyName.alloyName}
                            </Option>
                          ))}
                        </Select>
                        {errors.alloyName && (
                          <div className="errorField">{errors.alloyName}</div>
                        )}
                      </div>

                         <div className="col-md-6 col-lg-4 py-1">
                        <label className="labels">Temper Name</label>
                       <Select
                          value={temperName || undefined}
                          onChange={setTemperName}
                          showSearch
                          className="w-100"
                          placeholder="Select Name"
                          optionFilterProp="children"
                        >
                          {allTemper.map((temperName) => (
                            <Option key={temperName.id} value={temperName.id}>
                              {temperName.temperName}
                            </Option>
                          ))}
                        </Select>
                        {errors.temperName && (
                          <div className="errorField">{errors.temperName}</div>
                        )}
                      </div>

                      <div className="col-md-6 col-lg-4 py-1">
                        <label className="labels">Wt Range</label>
                        <Input
                          readOnly style={{backgroundColor:"#e6e6e6"}}
                          value={wtRange}
                          onChange={(e) => setWtRange(e.target.value)}
                          placeholder="Enter Range"
                          maxLength={250}
                        />
                        {errors.wtRange && <div className="errorField">{errors.wtRange}</div>}
                      </div>

                      <div className="col-md-6 col-lg-4 py-1">
                        <label className="labels">Quantity</label>
                        <Input
                          readOnly style={{backgroundColor:"#e6e6e6"}}
                          value={quantity}
                          onChange={(e) => setQuantity(e.target.value)}
                          placeholder="Enter Qty"
                          maxLength={250}
                        />
                        {errors.quantity && (
                          <div className="errorField">{errors.quantity}</div>
                        )}
                      </div>

                      <div className="col-md-6 col-lg-4 py-1">
                        <label className="labels">Output Remark</label>
                        <Input
                          value={outputRemark}
                          onChange={(e) => setOutputRemark(e.target.value)}
                          placeholder="Enter Remark"
                          maxLength={250}
                        />
                        {errors.outputRemark && (
                          <div className="errorField">{errors.outputRemark}</div>
                        )}
                      </div>

                      <div className="col-12 text-center pt-3">
                        <Button
                          type="submit"
                          className="CancelBtn mx-1"
                          onClick={handleNewStockAllCancel}
                        >
                          Cancel
                        </Button>
                        <Button
                          type="submit"
                          className="SubmitBtn mx-1"
                          onClick={handleNewStockEntrySubmit}
                        >
                          Submit
                        </Button>
                      </div>

                    </div>
                </div>
            )}

       

     

        </div>

    </div>
  )
}

export default PressOutput
